import { CircleCheckIcon } from '@/components/icons/circle-check-icon'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { T, useTranslate } from '@tolgee/react'
import { type ServiceToolsDialogData } from '../tab'
import React from 'react'

interface ServiceRegistryToolsDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  toolsDialogData: ServiceToolsDialogData
  setToolsDialogData: React.Dispatch<React.SetStateAction<ServiceToolsDialogData>>
}

export function ServiceRegistryToolsDialog({
  open,
  onOpenChange,
  toolsDialogData,
  setToolsDialogData,
}: ServiceRegistryToolsDialogProps) {
  const { t } = useTranslate()

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      setToolsDialogData({ serviceName: '', tools: [] })
    }
    onOpenChange(open)
  }

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent>
        <DialogHeader>
          <div className='flex items-center gap-2'>
            <CircleCheckIcon className='rounded-full bg-success-50 text-success-300' />
            <DialogTitle>
              <T keyName='serviceRegistry.toolsDialog.title' />
            </DialogTitle>
          </div>
          <DialogDescription>
            <T keyName='serviceRegistry.toolsDialog.description' />
          </DialogDescription>
        </DialogHeader>
        <div className='my-8 flex flex-col gap-3 font-light'>
          <p>
            <span className='font-normal'>
              <T keyName='serviceRegistry.toolsDialog.serviceName' />
            </span>{' '}
            {toolsDialogData?.serviceName}
          </p>
          <div className='flex gap-2'>
            <p className='font-normal'>
              <T keyName='serviceRegistry.toolsDialog.supportedTools' />
            </p>
            <ul className='max-h-[160px] max-w-[300px] overflow-y-auto'>
              {toolsDialogData?.tools.map((tool) => (
                <li key={tool}>{tool}</li>
              ))}
            </ul>
          </div>
        </div>
        <DialogFooter>
          <DialogClose asChild>
            <Button title={t('serviceRegistry.toolsDialog.close')}>
              <T keyName='serviceRegistry.toolsDialog.close' />
            </Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
